import script from "./GetReady.vue?vue&type=script&setup=true&lang=js"
export * from "./GetReady.vue?vue&type=script&setup=true&lang=js"

import "./GetReady.vue?vue&type=style&index=0&id=5972c9b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5972c9b4"]])

export default __exports__